'use client'

import dynamic from 'next/dynamic'

const UserMenu = dynamic(async () => import('./UserMenu').then((module) => module.UserMenu), { ssr: false })

interface Props {
  companyId: string
  venueId?: string
}

export function LazyUserMenu({ companyId, venueId }: Props) {
  return <UserMenu companyId={companyId} venueId={venueId} />
}
